<template >
    <div v-if="streamEvents?.length" class="res-card mb-2">
      <div @click.stop="toggleExpand" class="p-n fs-15 fw-600 sub-header desk-c-pointer" :class="{'geoff-border-bottom' : expanded}">
        <div>
                    
          <div v-if="liveEvent"><span class="tag-live me-2">LIVE STREAM</span> {{ liveEvent?.title }}</div>
          <div v-else-if="nextUpcoming">Next stream: {{ nextUpcoming?.title }} {{ nextUpcoming?.startDateTimeStr }}</div>
        </div>
        <div class="mx-2 collapse-btn-wr d-flex align-items-center">
          <svg  class="collapse-btn" :class="{'reverse':expanded}" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.00005 5.72376L10.862 0.861827L11.8048 1.80464L6.00005 7.60937L0.195312 1.80464L1.13812 0.861828L6.00005 5.72376Z" fill="currentColor"/>
          </svg>
        </div>
      </div>
      <collapse-transition :duration="200">
        <div class="p-n" v-if="expanded">

          <div class="container-fluid ">
            <div class="row">
              
              <div class="col-5 mb-2 ps-lg-0">
                <div  v-if="!$store.state.isMobile && upcomingEvents?.length">
                  <div class="list-header">Upcoming streams:</div>
                  <div class="stream-list-wr">
                    <div 
                      v-for="streamItem in upcomingEvents"
                      :key="streamItem.streamId"
                      class="stream-list-item"
                    >
                      <div>{{ streamItem.title }}</div>
                      <div>{{ streamItem.startDateTimeStr }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-7 px-0" :class="{ 'col-12': $store.state.isMobile }"> 
                <div class="video-container">
                  <div class="video mb-2"  :class="`ratio-SIS`">
                    <template v-if="liveEvent">
                      <div class="video mb-2" v-if="!streamSrc">
                        <pre-loader />
                      </div>
                      <iframe
                        v-else
                        sandbox="allow-scripts allow-same-origin"
                        allow="autoplay"
                        :src="streamSrc"
                        scrolling="no"
                        frameborder="no"
                        :width="'100%'"
                        :height="'100%'"
                        allowfullscreen
                      ></iframe>
                    </template>

                    <div v-else  class="no-stream p-2 text-center text-warning h-100 w-100">
                      <div class="logo" :style="{backgroundImage: 'url('+require('@/assets/logo.png')+')'}"></div>
                      <div>Thank you for your continued custom!</div>
                      <div>Live stream will commence shortly before the draw.</div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        
        </div>
      </collapse-transition> 
    </div>
</template>

<script>
  import moment from 'moment'
  import CollapseTransition from '@ivanv/vue-collapse-transition/src/CollapseTransition.vue'
  import PreLoader from "@/components/UI/PreLoader";

  export default {
    name: "LottoStreams",
    components: {
      CollapseTransition,
      PreLoader
    },
    data: () => {
      return {
        results: [],
        intervalLoad: null,
        streamLoadTimeoutInterval: null,
        expanded: false,
        streamEvents: null,
        streamSrc: null,
      }
    },
    computed: {

      upcomingEvents() {
        return this.streamEvents
          ?.filter(el => !el.isLive)
          ?.map(el => {
            return {
              ...el,
              startDateTimeStr: moment(el.startDate)?.format(' d MMM  HH:mm'),
              startTimeStr: moment(el.startDate)?.format('HH:mm')
            }
          })
      },
      nextUpcoming() {
        return this.upcomingEvents?.length ? this.upcomingEvents[0] : null
      },
      liveEvent() {
        return this.streamEvents?.find(el => el.isLive)
      },
    },
    watch: {
      'liveEvent.streamId'(val) {
        if (val) {
          this.startStream()
        }
      }
    },
    mounted( ) {
      this.loadStreams()
      this.intervalLoad = setInterval(()=>this.loadStreams(), 10000)

    },
    beforeUnmount() {
      if (this.intervalLoad) clearInterval(this.intervalLoad)
      if (this.streamLoadTimeoutInterval) clearInterval(this.streamLoadTimeoutInterval)
    },
    methods: {
      toggleExpand() {
        this.expanded = !this.expanded
      },
      loadStreams() {
        this.API.getSISLottoEvents()
          .then(resp => {
            this.streamEvents = resp
          })
      },
      startStream() {
        // clear timeout stream load (just in case)
        if (this.streamLoadTimeoutInterval) clearInterval(this.streamLoadTimeoutInterval)

        if(this.liveEvent) {
          this.getStreamSIS(this.liveEvent.streamId)
        }
      },

      getStreamSIS(streamId){
        // data for load video stream (stramId)
        const data = {
          streamId: streamId
        }
        // const prevVal = this.sisStreamId
         return this.API.getSISStream(data)
          .then((stream) => {

              if (stream.error ) {
                this.toast.warning(stream.error)
                console.error(stream.error)
                // try to reload
                this.streamLoad = setTimeout(()=>this.startStream(), 5000)
              }
              else {
                const video_url = stream.embedUrl ? stream.embedUrl : ''
                this.streamSrc = video_url
              }
          })
      
      },

    }
  }
</script>

<style scoped lang="scss">
  .res-card {
    width: auto;
    background-color: var(--geoff-bg-section);
    border-radius: 0.25rem;
  }

  .sub-header {
    font-size: 0.9375rem;
    font-weight: 600;
    justify-content: space-between;
  }

  .collapse-btn-wr {
    width: 12px;
    .collapse-btn {
      transition: transform 0.2s;

      &.reverse{
        transform: rotate(180deg);
      }
    }
  }

  .list-header {
    text-align: center;
  }
  .stream-list-wr {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    .stream-list-item {
      padding: 0.5rem;
      background-color: var(--geoff-item-lvl-2);
      border-radius: 0.25rem;
      display: flex;
      justify-content: space-between;

    }
  }


  .video-container {
    position: relative
  }
  .video { 
    min-height: 50px;
    aspect-ratio: 16 / 9;
    
    iframe {
      width: 100%;
    }

    &.ratio-SD365 { aspect-ratio: 4.7 / 3; }
    &.ratio-SD365_2 { aspect-ratio: 4.7 / 3; }
    &.ratio-TRP { aspect-ratio: 16 / 9; }
    &.ratio-SIS { aspect-ratio: 16 / 9; }
  }

  .no-stream {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 1rem;
    font-size: 0.85rem;
    
    .logo {
      background-size: contain;
      width: 60px;
      height: 60px;
      background-repeat: no-repeat;
    }
  }

  .tag-live {
    color: var(--geoff-mark-live);
    text-transform: uppercase;
    border: 1px solid var(--geoff-mark-live);
    padding: 3px 4px 1px;
    font-weight: 700;
    line-height: 1;
    border-radius: 0.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    display: inline-block;
  }

</style>